module.exports = __webpack_public_path__ + "static/media/grid-filled.1cdd9919.svg";